import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import SitiosPage from './pages/SitiosPage';
import AgentesPage from './pages/AgentesPage';
import RegistrosPage from './pages/RegistrosPage';
import RelacionesPage from './pages/RelacionesPage';
import ReportesPage from './pages/ReportesPage';
import EmpresasPage from './pages/EmpresasPage';
import UsuariosPage from './pages/UsuariosPage';
import TurnosPage from './pages/TurnosPage';
import CiclosPage from './pages/CiclosPage';
import AsignacionTurnosPage from './pages/AsignacionTurnosPage';
import AsistenciaCalculoPage from './pages/AsistenciaCalculoPage';
import TiposJustificacionesPage from './pages/TiposJustificacionesPage';
import AsignacionJustificacionesPage from './pages/AsignacionJustificacionesPage';
import FeriadosPage from './pages/FeriadosPage';
import AsignacionRotativosPage from './pages/AsignacionRotativosPage';
import ReporteRotativosPage from './pages/ReporteRotativosPage';
import RotativosPage from './pages/RotativosPage';
import { getCurrentUserRole } from './utils/auth';


const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  return token ? <>{children}</> : <Navigate to="/login" replace />;
};

const RoleRoute: React.FC<{ children: React.ReactNode; allowedRoles: Array<'ADMIN' | 'SUPERVISOR' | 'AGENTE'> }> = ({
  children,
  allowedRoles,
}) => {
  const role = getCurrentUserRole();
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/sin-acceso" replace />;
  }
  return <>{children}</>;
};

const AccessDeniedPage: React.FC = () => (
  <div className="card" style={{ maxWidth: '680px', margin: '2rem auto' }}>
    <h2 className="card-title">Sin permisos</h2>
    <p>No tenes permisos para acceder a esta seccion.</p>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/sitios" replace />} />
          <Route path="sitios" element={<SitiosPage />} />
          <Route path="agentes" element={<AgentesPage />} />
          <Route
            path="empresas"
            element={
              <RoleRoute allowedRoles={['ADMIN']}>
                <EmpresasPage />
              </RoleRoute>
            }
          />
          <Route
            path="usuarios"
            element={
              <RoleRoute allowedRoles={['ADMIN']}>
                <UsuariosPage />
              </RoleRoute>
            }
          />
          <Route path="registros" element={<RegistrosPage />} />
          <Route
            path="relaciones"
            element={
              <RoleRoute allowedRoles={['ADMIN']}>
                <RelacionesPage />
              </RoleRoute>
            }
          />
          <Route
            path="reportes"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <ReportesPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/turno"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <TurnosPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/ciclos"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <CiclosPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/asignacion"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <AsignacionTurnosPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/calculo-asistencia"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <AsistenciaCalculoPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/tipos-justificaciones"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <TiposJustificacionesPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/asignacion-justificaciones"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <AsignacionJustificacionesPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/feriados"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <FeriadosPage />
              </RoleRoute>
            }
          />
          <Route
            path="turnos/asignacion-rotativos"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <AsignacionRotativosPage />
              </RoleRoute>
            }
          />
          <Route
            path="reporte-rotativos"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <ReporteRotativosPage />
              </RoleRoute>
            }
          />
          <Route
            path="rotativos"
            element={
              <RoleRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                <RotativosPage />
              </RoleRoute>
            }
          />
          <Route path="sin-acceso" element={<AccessDeniedPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/sitios" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
